import React from 'react';
import useAuth from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import '../gral-stylesheets/dropdown.scss';



const Logout = (props) => {

  const { setAuth } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('id');
    localStorage.removeItem('email');
    localStorage.removeItem('password');
    localStorage.removeItem('token');
    localStorage.removeItem('profileImage');
    localStorage.removeItem('personalInfo');
    setAuth({});
    navigate('/');
  }

  return (
    <div
      className='user-item-bottom'
      onClick={handleLogout}
    >
      <div className='user-logout'>
        <i>{props.icon}</i>
        <h4>Logout</h4>
      </div>
    </div>
  )
}

export default Logout;